import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api/axios";
import Logo from "../components/Logo";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [password,  setPassword]  = useState("");
  const [confirm,   setConfirm]   = useState("");
  const [msg,       setMsg]       = useState("");
  const [err,       setErr]       = useState("");
  const [loading,   setLoading]   = useState(false);

  const inp = {
    width:"100%", marginTop:6, padding:"12px 14px", borderRadius:10,
    border:"1px solid #1e293b", background:"#0d0d0d", color:"#f1f5f9",
    fontSize:14, outline:"none", boxSizing:"border-box"
  };

  const submit = async e => {
    e.preventDefault();
    setErr(""); setMsg("");
    if (password !== confirm)
      return setErr("Passwords do not match");
    setLoading(true);
    try {
      const { data } = await api.post(`/auth/reset-password/${token}`, { password });
      setMsg(data.message);
      setTimeout(() => nav("/login"), 2500);
    } catch (e) {
      setErr(e.response?.data?.message || "Something went wrong");
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight:"100vh", background:"#0a0a0a", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24 }}>
      <div style={{ background:"#111111", borderRadius:16, border:"1px solid #1e293b", padding:"36px 28px", width:"100%", maxWidth:400 }}>

        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div style={{ display:"flex", justifyContent:"center", marginBottom:6 }}>
            <Logo size={28} />
          </div>
          <div style={{ fontSize:20, fontWeight:700, color:"#f1f5f9", marginBottom:4 }}>Set New Password</div>
          <div style={{ fontSize:13, color:"#475569" }}>Enter your new password below</div>
        </div>

        {msg ? (
          <div style={{ color:"#22c55e", fontSize:14, background:"#22c55e15", padding:"12px 14px", borderRadius:8, border:"1px solid #22c55e30", textAlign:"center" }}>
            {msg} Redirecting to login...
          </div>
        ) : (
          <form onSubmit={submit}>
            <div style={{ marginBottom:14 }}>
              <label style={{ fontSize:13, color:"#64748b", fontWeight:500 }}>New Password</label>
              <input
                required
                type="password"
                style={inp}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Min 8 characters"
                minLength={8}
              />
            </div>

            <div style={{ marginBottom:20 }}>
              <label style={{ fontSize:13, color:"#64748b", fontWeight:500 }}>Confirm Password</label>
              <input
                required
                type="password"
                style={inp}
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                placeholder="••••••••"
              />
            </div>

            {err && (
              <div style={{ color:"#ef4444", fontSize:13, marginBottom:14, background:"#ef444415", padding:"10px 14px", borderRadius:8, border:"1px solid #ef444430" }}>
                {err}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{ width:"100%", padding:13, background:"#f97316", color:"#fff", border:"none", borderRadius:10, fontSize:15, fontWeight:700, cursor:"pointer" }}
            >
              {loading ? "Updating..." : "Update Password →"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
